<template>
    <Layout is-crm class="order-default-speakers-page" :content-class="'content--centered'">
        <header class="page__top">
            <h1 v-t="'crm.defaultSpeakers.title'" />
        </header>
        <PaginatedResource
            ref="speakersRes"
            :fetch-method="fetchOrderDefaultSpeakers"
            :sorting-fields="sortingFields"
        >
            <template
                #default="{ loading, canLoadMore, resource: items, isEmpty, notFound, loadMore }"
            >
                <div class="order-default-speakers-page__results">
                    <Spinner v-if="loading" />
                    <table class="control-table">
                        <thead class="control-table__head">
                            <tr class="control-table__row">
                                <th class="control-table__cell" style="width: 150px">
                                    <div class="control-table__cell-inner">
                                        <span v-text="'ID'" />
                                        <TableSorting v-model="ordering" field="id" />
                                    </div>
                                </th>
                                <th class="control-table__cell">
                                    <div class="control-table__cell-inner">
                                        <span v-t="'misc.language'" />
                                        <TableSorting v-model="ordering" field="language" />
                                    </div>
                                </th>
                                <th class="control-table__cell">
                                    <div class="control-table__cell-inner">
                                        <span v-t="'misc.voice'" />
                                        <TableSorting v-model="ordering" field="speaker" />
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="!loading">
                                <tr v-if="isEmpty" class="control-table__row">
                                    <td
                                        class="table__cell table__cell--centered table__empty"
                                        colspan="3"
                                    >
                                        {{ $t('crm.defaultSpeakers.results.noData') }}
                                    </td>
                                </tr>
                                <tr v-else-if="notFound" class="control-table__row">
                                    <td
                                        class="table__cell table__cell--centered table__empty"
                                        colspan="3"
                                    >
                                        {{ $t('crm.defaultSpeakers.results.noResults') }}
                                    </td>
                                </tr>
                                <tr v-for="item in items" :key="item.id" class="control-table__row">
                                    <td class="control-table__cell">
                                        <span v-text="item.id" />
                                    </td>
                                    <td class="control-table__cell">
                                        <span v-text="item.language.label" />
                                    </td>
                                    <td class="control-table__cell">
                                        <span v-text="item.speaker.name[$i18n.locale]" />
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <div v-if="canLoadMore" class="order-default-speakers-page__loadmore">
                        <button
                            v-t="'misc.loadmore'"
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        />
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </Layout>
</template>

<script>
import { fetchOrderDefaultSpeakers } from '../../api/orders';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import TableSorting from '@speechki-frontend/shared/ui/TableSorting';

export default {
    name: 'OrderDefaultSpeakersPage',
    components: {
        Layout,
        PaginatedResource,
        TableSorting,
    },
    data() {
        return {
            sortingFields: ['id', 'language', 'speaker'],
            ordering: '-id',
        };
    },
    computed: {
        orderId() {
            const { id } = this.$route.params;
            return id;
        },
    },
    watch: {
        ordering(value) {
            this.$refs.speakersRes.sort(value);
        },
    },
    methods: {
        fetchOrderDefaultSpeakers(params = {}) {
            return fetchOrderDefaultSpeakers(this.orderId, params);
        },
    },
};
</script>

<style src="./OrderDefaultSpeakersPage.scss" lang="scss"></style>
